export const text = {
    title: "About SAFEPATH",
    aimText: `
        The aim of the SAFE caPAciTy Highways (SAFEPATH) project is to provide National Road Authorities (NRAs) with accessible 
        information and methodologies that will support the selection of appropriate measures to safely increase highway capacity. 
        This project is funded through CEDR Transnational Research Road Programme`,
    aimlink: "https://cedr.eu/peb-call-2019-safe-smart-highways",
    aimLinkText: "Call 2019 Safe Smart Highways",
    websiteDeliverableText: `
        This website is one of the deliverables of the SAFEPATH project. This website gives access to the database that
        contains a wide variety of projects and measures, with an assessment of their impact on highway capacity, safety,
        and other relevant environmental, financial, and societal factors. This database aims to provide a detailed overview
        of various types of measures, their implementation details, and how well they perform in terms of improving highway
        capacity and road safety. These measures were collected through interviews with relevant stakeholders, virtual workshops,
        online questionnaires, and desktop literature research.`,
    participatingNRAsText: `
        The participating/funding National Road Authorities (NRAs) in this Call are Austria, Belgium (Wallonia), 
        Finland, Germany, Hungary, Ireland, Netherlands, Sweden, United Kingdom.`,
    projectPartnersBold: "Project Partners:",
    projectPartnersText: "AECOM (United Kingdom, coordinator), Royal HaskoningDHV (Netherlands), Eindhoven University of Technology (Netherlands), White Willow (United Kingdom).",
    CEDRBold: "About CEDR:",
    CEDRText1: `
        CEDR is an organisation that brings together the directors of 29 European road authorities. 
        CEDR provides a platform for cooperation and promotion of improvements to the road system and its infrastructure, 
        as an integral part of a sustainable transport system in Europe. The website `,
    CEDRText2: ` contains a full description of its structure and activities.`,
    CEDRLink: "https://www.cedr.eu/",
};
